import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUICardHeader(theme: Theme): Components['MuiCardHeader'] {
  return {
    defaultProps: {
      titleTypographyProps: {
        variant: 'subtitle1',
      },
      subheaderTypographyProps: {
        variant: 'body2',
      },
    },
    styleOverrides: {
      root: {
        padding: theme.spacing(3, 3, 0),
      },
    },
  };
}
